import "./index.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _friendSites = _interopRequireDefault(require("./friend-sites"));

var _component = require("../_utils/component");

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _vueNormalizeComponent = _interopRequireDefault(require("../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('footer'),
  components: {
    Tooltip: _Tooltip.default,
    Icon: _Icon.default
  },
  mixins: [_component.componentMixin],
  props: {
    // logo标题
    title: {
      type: String,
      default: '稿定设计'
    },
    // 点击logo跳转的路由
    route: {
      type: String,
      default: '/'
    },
    isShowFriendSites: {
      type: Boolean,
      default: true
    },
    // 友情链接, 如果没有传入, 会用默认的数据
    friendSites: {
      // `{ name: string, href: string }[]`
      type: Array,
      default: function _default() {
        return _friendSites.default;
      }
    }
  },
  friendSites: _friendSites.default
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    class: _vm.bem()
  }, [_c("div", {
    class: _vm.bem("main")
  }, [_c("div", {
    class: _vm.bem("links")
  }, [_vm._m(0)]), _vm._v(" "), _c("div", {
    class: _vm.bem("copyright")
  }, [_c("p", [_vm._v("闽ICP备18003982号-2 | COPYRIGHT 2019. ALL RIGHTS RESERVED")]), _vm._v(" "), _c("p", [_c("span", {
    class: _vm.bem("contact-item")
  }, [_vm._v("联系我们：厦门市湖里区高林中路535号万科云玺27楼")]), _vm._v(" "), _c("span", {
    class: _vm.bem("contact-item")
  }, [_vm._v("商业合作: bd@gaoding.com")])])]), _vm._v(" "), _c("div", {
    class: _vm.bem("qr-codes")
  }, [_c("div", [_c("a", {
    attrs: {
      rel: "nofollow",
      target: "_blank",
      href: "https://weibo.com/gaodingsheji"
    }
  }, [_c("Icon", {
    class: _vm.bem("ic-weibo"),
    attrs: {
      name: "weibo"
    }
  })], 1)]), _vm._v(" "), _c("Tooltip", {
    attrs: {
      theme: "light",
      placement: "top"
    }
  }, [_c("Icon", {
    class: _vm.bem("ic-wechat"),
    attrs: {
      name: "link"
    }
  }), _vm._v(" "), _c("div", {
    class: _vm.bem("popover-content"),
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, [_c("img", {
    class: _vm.bem("qrcode"),
    attrs: {
      src: require("../../assets/img/wxacode.jpg")
    }
  }), _vm._v("\n                    扫码打开小程序\n                ")])], 1), _vm._v(" "), _c("Tooltip", {
    attrs: {
      theme: "light",
      placement: "top"
    }
  }, [_c("Icon", {
    class: _vm.bem("ic-weapp"),
    attrs: {
      name: "wechat"
    }
  }), _vm._v(" "), _c("div", {
    class: _vm.bem("popover-content"),
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, [_c("img", {
    class: _vm.bem("qr-code-wechat"),
    attrs: {
      src: require("../../assets/img/footer-qr-code-wechat.png")
    }
  }), _vm._v("\n                    扫码关注公众号\n                ")])], 1), _vm._v(" "), _c("Tooltip", {
    attrs: {
      theme: "light",
      placement: "top"
    }
  }, [_c("Icon", {
    class: _vm.bem("ic-phone"),
    attrs: {
      name: "phone"
    }
  }), _vm._v(" "), _c("div", {
    class: _vm.bem("popover-content"),
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, [_c("img", {
    class: _vm.bem("qrcode"),
    attrs: {
      src: require("../../assets/img/ttxs-qrcode.png")
    }
  }), _vm._v("\n                    扫码下载移动端\n                ")])], 1)], 1)]), _vm._v(" "), _vm._t("friend-site", [_c("div", {
    class: _vm.bem("friend-site-wrapper")
  }, [_vm.friendSites.length && _vm.isShowFriendSites ? _c("div", {
    class: _vm.bem("friend-site")
  }, [_c("div", {
    class: _vm.bem("site-list")
  }, _vm._l(_vm.friendSites, function (site) {
    return _c("a", {
      key: site.href,
      ref: "nofollow",
      refInFor: true,
      attrs: {
        href: site.href,
        target: "_blank"
      }
    }, [_vm._v(_vm._s(site.name))]);
  }), 0)]) : _vm._e()])]), _vm._v(" "), _vm._t("bottom")], 2);
};

var __vue_staticRenderFns__ = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("ul", [_c("li", [_c("a", {
    attrs: {
      href: "https://www.gaoding.com/about",
      rel: "nofollow"
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c("li", [_c("a", {
    attrs: {
      href: "https://www.gaoding.com/help",
      rel: "nofollow"
    }
  }, [_vm._v("帮助中心")])])]);
}];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default2 = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default2;